import { admin2 } from '@/api/instance'

const baseUrl = (shopId) => {
  return `/${shopId}/shopCustomModule`
}

export const GetCustomModule = async ({
  shopId,
  start,
  limit,
  type,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/shopCustomModule`,
    params: {
      start,
      limit,
      type,
    },
  })
}

export const GetCustomModuleCount = async ({
  shopId,
  type,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/shopCustomModule/count`,
    params: {
      type,
    },
  })
}

export const FindCustomModule = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/shopCustomModule/${id}`,
  })
}

// PUT admin.shopCustomModule.updatePosPalCustomDisplayName
/**
 * 更新 PosPal 自定義名稱
 * @param {Object} params
 * @param {string} params.shopId - 店家 ID
 * @param {Array} params.customDisplayName - 陣列，每個元素需包含 label, displayName, 可選 additionalSetting
 * @example
 * customDisplayName: [
 *   {
 *     label: 'xxx',
 *     displayName: 'yyy',
 *     additionalSetting: {
 *       displayMemberWalletAmount: true,
 *       displayMemberWalletAmountIcon: false,
 *       displayMemberPassProductAmount: true,
 *       displayMemberPassProductAmountIcon: true
 *     }
 *   }
 * ]
 */
export const UpdatePosPalCustomDisplayName = async ({
  shopId,
  customDisplayName,
}) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/shopCustomModule/posPal/customDisplayName`,
    data: {
      type: 'posPal',
      customDisplayName,
    },
  })
}

// POST admin.shopCustomModule.createTkhspcClient
/**
 * 創建凱惠 POS 串接設定
 * @param {Object} params
 * @param {string} params.shopId - 店家 ID
 * @param {boolean} params.enabled - 是否啟用
 * @param {Object} params.config - 設定物件
 * @param {string} params.config.appId - 門店 appId
 * @param {boolean} params.config.enableFrequentUpdate - 是否啟用 4 小時更新
 * @param {boolean} params.config.enableManualUpdate - 是否啟用後台刷新
 * @param {boolean} params.config.enableTkhspcCoupon - 是否啟用凱惠優惠券同步
 */
export const CreateTkhspcClient = async ({
  shopId,
  enabled,
  config,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/shopCustomModule/tkhspc`,
    data: {
      enabled,
      config,
    },
  })
}

// PUT admin.shopCustomModule.updateTkhspcClient
/**
 * 更新凱惠 POS 串接設定
 * @param {Object} params
 * @param {string} params.shopId - 店家 ID
 * @param {boolean} params.enabled - 是否啟用
 * @param {Object} params.config - 設定物件
 * @param {string} params.config.appId - 門店 appId
 * @param {boolean} params.config.enableFrequentUpdate - 是否啟用 4 小時更新
 * @param {boolean} params.config.enableManualUpdate - 是否啟用後台刷新
 * @param {boolean} params.config.enableTkhspcCoupon - 是否啟用凱惠優惠券同步
 */
export const UpdateTkhspcClient = async ({
  shopId,
  enabled,
  config,
}) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/shopCustomModule/tkhspc`,
    data: {
      enabled,
      config,
    },
  })
}

// POST admin.shopCustomModule.syncTkhspcMemberImmidately
export const SyncTkhspcMemberImmidately = async ({
  shopId,
  memberId,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/shopCustomModule/syncTkhspcMemberImmidately`,
    data: {
      memberId,
    },
  })
}

// POST admin.shopCustomModule.syncTkhspcCoupon
export const SyncTkhspcCoupon = async ({
  shopId,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/shopCustomModule/syncTkhspcCoupon`,
  })
}

// POST admin.shopCustomModule.manualSyncTkhspcUpdates
export const ManualSyncTkhspcUpdates = async ({
  shopId,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/shopCustomModule/manualSyncTkhspcUpdates`,
  })
}

// GET admin.couponTkhspc.find
export const GetTkhspcCoupon = async ({
  shopId,
  name,
  start,
  limit,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponTkhspc`,
    params: {
      name,
      start,
      limit,
    },
  })
}

// GET admin.couponTkhspc.count
export const CountTkhspcCoupon = async ({
  shopId,
  name,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponTkhspc/count`,
    params: {
      name,
    },
  })
}

// GET admin.couponTkhspc.findOne
export const FindOneTkhspcCoupon = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponTkhspc/${id}`,
  })
}

// POST admin.couponTkhspc.resendCouponCode
export const ResendTkhspcCouponCode = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/couponTkhspc/${id}/resendCouponCode`,
  })
}

/**
 * 建立 Miezo 鳴周門禁串接設定 admin.shopCustomModule.createMiezoClient
 * @param {Object} params - 請求參數
 * @param {string} params.shopId - 商店ID
 * @param {boolean} [params.enabled=true] - 是否啟用
 * @param {Object} params.config - 設定內容
 * @param {string} params.config.miezoToken - 鳴周 API Token
 * @returns {Promise<Object>} 建立的設定資料
 */
export const CreateMiezoClient = async ({
  shopId,
  config,
  enabled = true,
}) => {
  return admin2({
    method: 'post',
    url: `${baseUrl(shopId)}/miezo`,
    data: {
      enabled,
      config,
    },
  })
}

/**
 * 更新 Miezo 鳴周門禁串接設定 admin.shopCustomModule.updateMiezoClient
 * @param {Object} params - 請求參數
 * @param {string} params.shopId - 商店ID
 * @param {boolean} [params.enabled=true] - 是否啟用
 * @param {Object} params.config - 設定內容
 * @param {string} params.config.miezoToken - 鳴周 API Token
 * @returns {Promise<Object>} 更新後的設定資料
 */
export const UpdateMiezoClient = async ({
  shopId,
  config,
  enabled = true,
}) => {
  return admin2({
    method: 'put',
    url: `${baseUrl(shopId)}/miezo`,
    data: {
      enabled,
      config,
    },
  })
}
